const PDF_MIME_TYPE = 'application/pdf';
const PDF_RENDER_SCALE = 2;
const JPEG_QUALITY = 0.85;

export function isPdfFile(file: File): boolean {
  return file.type === PDF_MIME_TYPE || file.name.toLowerCase().endsWith('.pdf');
}

export async function convertPdfToImageFile(file: File): Promise<File> {
  const pdfjs = await import('pdfjs-dist');
  const pdfWorker = await import('pdfjs-dist/build/pdf.worker.entry');
  pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker.default || pdfWorker;

  const data = await file.arrayBuffer();
  const pdf = await pdfjs.getDocument({ data }).promise;

  try {
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: PDF_RENDER_SCALE });

    const canvas = document.createElement('canvas');
    canvas.width = Math.floor(viewport.width);
    canvas.height = Math.floor(viewport.height);

    const context = canvas.getContext('2d');
    if (!context) {
      throw new Error('Canvas 2d context unavailable');
    }

    await page.render({ canvasContext: context, viewport }).promise;

    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, 'image/jpeg', JPEG_QUALITY)
    );

    if (!blob) {
      throw new Error('Failed to render PDF page as image');
    }

    const fileName = `${file.name.replace(/\.pdf$/i, '')}.jpg`;

    return new File([blob], fileName, { type: 'image/jpeg' });
  } finally {
    await pdf.destroy();
  }
}
